import request from '@/utils/request'

/**
 * 仪表盘
**/
export function getAdminDashboard(params = {}) {
  return request({
    method: 'POST',
    url: 'dashboard.admininfo',
    data: {
      ...params,
    }
  })
}
export function getAgentDashboard(params = {}) {
  return request({
    method: 'POST',
    url: 'dashboard.agentinfo',
    data: {
      ...params,
    }
  })
}
export function getCustomerDashboard(params = {}) {
  return request({
    method: 'POST',
    url: 'dashboard.customerinfo',
    data: {
      ...params,
    }
  })
}

/**
 * 用电量
**/
export function getAllDeviceMetrics(params = {}) {
  return request({
    method: 'POST',
    url: 'metrics.all',
    data: params
  })
}
export function getAgentDeviceMetrics(params = {}) {
  return request({
    method: 'POST',
    url: 'metrics.agent',
    data: params
  })
}
export function getCustomerDeviceMetrics(params = {}) {
  return request({
    method: 'POST',
    url: 'metrics.customer',
    data: params
  })
}
export function getDailyDeviceMetrics(params = {}) {
  return request({
    method: 'POST',
    url: 'metrics.daily',
    data: params
  })
}


/**
 * 设备
**/
export function getDeviceList(params = {}) {
  return request({
    method: 'POST',
    url: 'device.list',
    data: params
  })
}
export function getDeviceDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'device.detail',
    data: params
  })
}
export function updateDevice(params = {}) {
  return request({
    method: 'POST',
    url: 'device.update',
    data: params
  })
}

/**
 * 客户
**/
export function getCustomerList(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.list',
    data: params
  })
}
export function getCustomerDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.detail',
    data: params
  })
}
export function updateCustomer(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.update',
    data: params
  })
}

/**
 * 经纪
**/
export function getAgentListTo(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.listto',
    data: params
  })
}
export function getAgentList(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.list',
    data: params
  })
}
export function getAgentDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.detail',
    data: params
  })
}
export function updateAgent(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.update',
    data: params
  })
}

/**
 * 用户
**/
export function getUserInfo(){
  return request({
    method: 'POST',
    url: 'user.info',
  })
}
export function editUserInfo(params) {
  return request({
    method: 'POST',
    url: 'user.edit',
    data: params
  })
}

/**
 * 登录
**/
export function register(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.signup',
    data: params
  })
}
export function login(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.signin',
    data: params,
  })
}
export function forgetPassword(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.forgotpass',
    data: params,
  })
}
export function resetPassword(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.resetpass',
    data: params,
  })
}
